export default __webpack_public_path__ + "static/media/own-space.623180f9.png";